import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import Typography from '@material-ui/core/Typography'
import { Link as RouterLink } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
  root: {
    '& > * + *': {
      margin: theme.spacing(2),
    },
  },
  m4: {
    margin: '40px 40px 0',
  },
  linkstyle: {
    color: 'gray',
    textDecoration: 'none',
  }
}))

const Breadcrumb = (props) => {
  const classes = useStyles()

  let path = window.location.pathname
  path = path.split('/').filter(st => st)

  let breadcrumb = []
  for (let i = 0; i < path.length - 1; i++) {
    breadcrumb.push(
      <RouterLink className={classes.linkstyle} color="inherit" to={`/${path[i]}`} >
        {path[i].replace(/(\w)(\w*)/g, (g0, g1, g2) => { return g1.toUpperCase() + g2.toLowerCase() })}
      </RouterLink >
    )
  }

  return (
    <div className={`${classes.root} ${classes.m4}`}>
      {props && props.value ?
        <Breadcrumbs separator="›" aria-label="breadcrumb">
          {props.value.map((val, index) => {
            if (index + 1 === props.value.length) {
              return <Typography key={index} color="primary">{Object.keys(val)[0]}</Typography>
            } else {
              for (const key in val) {
                return <RouterLink key={index} className={classes.linkstyle} color="inherit" to={{ pathname: `${val[key]}`, state: val['state'] ? { ...val['state'] } : undefined, ...(val['search'] ? { search: `${val['search']}` } : {}) }} >{key}</RouterLink>
              }
            }
          })}
        </Breadcrumbs>
        :
        <Breadcrumbs separator="›" aria-label="breadcrumb">
          <RouterLink className={classes.linkstyle} to="/" >
            Home
        </RouterLink>
          {breadcrumb}
          <Typography color="primary">{path[path.length - 1].replace(/(\w)(\w*)/g, (g0, g1, g2) => { return g1.toUpperCase() + g2.toLowerCase() })}</Typography>
        </Breadcrumbs>
      }
    </div >
  )
}

export default Breadcrumb